import React, { useState, useEffect } from "react";
import { Card, CardContent, Button, Box } from "@mui/material";

export const ExpandableCard = ({ children }) => {
   const [expanded, setExpanded] = useState(false);
   const [maxHeight, setMaxHeight] = useState("calc(34vh - 0px)"); // Defaultwert

   const calculateHeight = () => {
      const viewportHeight = document.documentElement.clientHeight; // Gesamthöhe des Fensters
      const bottomMargin = 560; // Mindestabstand vom Boden in px
      const calculatedHeight = viewportHeight - bottomMargin; // Höhe, die übrig bleibt
      return `${calculatedHeight}px`;
   };

   useEffect(() => {
      const updateHeight = () => {
         setMaxHeight(calculateHeight());
      };

      updateHeight(); // Initiale Berechnung
      window.addEventListener("resize", updateHeight); // Reagieren auf Fenstergrößenänderungen
      window.addEventListener("scroll", updateHeight); // Hinzufügen eines Scroll-Events

      return () => {
         window.removeEventListener("resize", updateHeight);
         window.removeEventListener("scroll", updateHeight);
      };
   }, []);

   const toggleExpand = () => {
      setExpanded(!expanded);
   };

   return (
      <Card sx={{ maxWidth: 400, margin: "auto", position: "relative" }}>
         <CardContent
            sx={{
               position: "relative",
               overflow: "hidden",
               maxHeight: expanded ? "none" : maxHeight,
            }}
         >
            <Box
               elevation={0} 
               sx={{
                  position: "relative",
               }}
            >
               {/* Der gesamte Text wird hier gerendert */}
               <Box elevation={0} sx={{ marginBottom: "8px" }}>
                  {children}
               </Box>
            </Box>

            {/* Die überlagernde Box mit dem Gradient */}
            {!expanded && (
               <Box
                  sx={{
                     position: "absolute",
                     bottom: 0,
                     left: 0,
                     right: 0,
                     height: "100px",
                     background: "linear-gradient(transparent, white)",
                     pointerEvents: "none",
                  }}
               />
            )}
         </CardContent>
         <Box
            sx={{
               display: "flex",
               justifyContent: "center",
               padding: "0 16px 16px",
            }}
         >
            <Button color={"baerendark"} size={"small"} variant={"outlined"} onClick={toggleExpand}>
               {expanded ? "Weniger anzeigen" : "Alles anzeigen"}
            </Button>
         </Box>
      </Card>
   );
};